import React, { useEffect, useState, useContext } from 'react'
import { Box } from '../../../../Components/Layout'
import { SectionHeading } from '../../../../Components/Headers'
import { FeedCardList } from '../../../../Components/Feed'
import { MatchupContext } from '../../../../Context'
import type { FeedItem } from '../../../../Api'

export const Media: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { gameFeed, fetchGameFeed } = useContext(MatchupContext)!
  const [feed, setFeed] = useState<FeedItem[]>([])

  useEffect(() => {
    if (gameFeed.length < 1) {
      getNews()
    }
    setFeed(gameFeed)
  }, [])

  const getNews = async () => {
    const feedItems = await fetchGameFeed(true)
    if (!feedItems) return
    setFeed(feedItems)
  }

  return (
    <>
      {feed?.length > 0 && (
        <Box boxColor="grey">
          <SectionHeading headingColor="light">
            <strong>News</strong>
          </SectionHeading>
          <FeedCardList feedItems={feed} section={'matchup_summary_feed'} theme="dark" />
        </Box>
      )}
    </>
  )
}
